<template>
  <section class="mb-12 text-center">
    <h1 class="font-weight-light mb-2 headline">
      {{heading}}
  </h1>

    <span
      class="font-weight-light subtitle-1"
    />
  </section>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'VComponent',

    props: {
      heading: {
        type: String,
        default: 'Incompos Dashboard',
      },
      subHeading: {
        type: String,
        default: '',
      },
    },
  }
</script>
